import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { carouselItemClass } from './carousel-item.class'
import {
  createMediaQuery,
  createCustomMediaQuery,
} from '../../../../__aeki__/components/style-class/style-class.utils'
import { StyleClass } from '../../../../__aeki__/components/style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for carousel
   */
  base: string

  /**
   * Themed class for carousel
   */
  baseThemed: string
}

type ClassProps = {
  columns?: [number, number, number, number]
  customColums?: { maxWidth: number | null; column: number }[]
  isSpaced?: boolean
}

const SPACING = 0
const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const { columns = [4, 3, 2, 1], isSpaced, customColums } = props

  const base = style({
    display: 'flex',
    overflow: 'hidden',
    scrollBehavior: 'smooth',
  })

  let baseThemed

  baseThemed = style({
    $nest: {
      // Carousel Item Base
      [`& .${carouselItemClass.names.base}`]: {
        boxSizing: 'border-box',
        // marginBottom: isSpaced ? 30 : 0,
        paddingRight: isSpaced ? 16 : 0,
        maxWidth: `calc(${100 / columns[0]}% - ${SPACING}px)`,
      },
      [`& .${carouselItemClass.names.base}:nth-child(${columns[0]}n)`]: {
        paddingRight: 0,
      },
      ...createMediaQuery['lg']({
        // Carousel Item Base
        [`& .${carouselItemClass.names.base}`]: {
          maxWidth: `calc(${100 / columns[1]}% - ${SPACING / 2}px)`,
          paddingRight: isSpaced ? 16 : 0,
        },
        [`& .${carouselItemClass.names.base}:nth-child(${columns[1]}n)`]: {
          paddingRight: 0,
        },
      }),
      ...createMediaQuery['md']({
        // Carousel Item Base
        [`& .${carouselItemClass.names.base}`]: {
          maxWidth: `calc(${100 / columns[2]}% - ${SPACING / 2}px)`,
          paddingRight: isSpaced ? 16 : 0,
        },
        [`& .${carouselItemClass.names.base}:nth-child(${columns[2]}n)`]: {
          paddingRight: 0,
        },
      }),
      ...createMediaQuery['sm']({
        // Carousel Item Base
        [`& .${carouselItemClass.names.base}`]: {
          maxWidth: `calc(${100 / columns[3]}% - ${0}px)`,
          paddingRight: isSpaced ? 16 : 0,
        },
        [`& .${carouselItemClass.names.base}:nth-child(${columns[3]}n)`]: {
          paddingRight: 0,
        },
      }),
    },
  })

  if (customColums) {
    baseThemed = style({
      $nest: {
        ...(() => {
          let query = {}

          customColums.map(({ maxWidth, column }: any) => {
            if (!maxWidth) {
              query = {
                ...query,
                // Carousel Item Base
                [`& .${carouselItemClass.names.base}`]: {
                  maxWidth: `calc(${100 / column}% - ${16}px)`,
                  flex: `0 0 ${100 / column}%`,
                  paddingRight: isSpaced ? 16 : 0,
                },
                [`& .${carouselItemClass.names.base}:nth-child(${column}n)`]: {
                  paddingRight: 0,
                },
              }
            } else {
              query = {
                ...query,
                ...createCustomMediaQuery({
                  maxWidth,
                  style: {
                    // Carousel Item Base
                    [`& .${carouselItemClass.names.base}`]: {
                      maxWidth: `calc(${100 / column}% - ${16}px)`,
                      flex: `0 0 ${100 / column}%`,
                      paddingRight: isSpaced ? 16 : 0,
                    },
                    [`& .${carouselItemClass.names.base}:nth-child(${column}n)`]: {
                      paddingRight: 0,
                    },
                  },
                }),
              }
            }
          })

          return query
        })(),
      },
    })
  }

  return {
    base,
    baseThemed,
  }
}

/* Export ======================================================================================= */
export const carouselClass = new StyleClass<ClassNames, ClassProps>(getNames)
